export default function parseHumanFloat(string: string): number | null {
	const parts = string.match(/^(-?[0-9]+)([,.]([0-9]+))?$/);
	if (parts === null) {
		return null;
	}

	const number = parseFloat(parts[3] === undefined ? parts[1] : `${parts[1]}.${parts[3]}`);
	return Number.isNaN(number) ? null : number;
}
